const changeTab = tab => ({
  type: 'CHANGE_TAB',
  tab,
});

export default changeTab;



// WEBPACK FOOTER //
// ./src/Sidebar/actionCreators.js